__turbopack_context__.v({
  "divider": "NotificationDropdown-module__rMmnvq__divider",
  "dot": "NotificationDropdown-module__rMmnvq__dot",
  "dotHidden": "NotificationDropdown-module__rMmnvq__dotHidden",
  "header": "NotificationDropdown-module__rMmnvq__header",
  "headerTitle": "NotificationDropdown-module__rMmnvq__headerTitle",
  "item": "NotificationDropdown-module__rMmnvq__item",
  "itemButton": "NotificationDropdown-module__rMmnvq__itemButton",
  "itemClickable": "NotificationDropdown-module__rMmnvq__itemClickable",
  "itemContent": "NotificationDropdown-module__rMmnvq__itemContent",
  "itemDescription": "NotificationDropdown-module__rMmnvq__itemDescription",
  "itemRead": "NotificationDropdown-module__rMmnvq__itemRead",
  "itemTime": "NotificationDropdown-module__rMmnvq__itemTime",
  "itemTitle": "NotificationDropdown-module__rMmnvq__itemTitle",
  "itemUnread": "NotificationDropdown-module__rMmnvq__itemUnread",
  "list": "NotificationDropdown-module__rMmnvq__list",
  "panel": "NotificationDropdown-module__rMmnvq__panel",
  "state": "NotificationDropdown-module__rMmnvq__state",
  "stateError": "NotificationDropdown-module__rMmnvq__stateError",
  "viewAll": "NotificationDropdown-module__rMmnvq__viewAll",
  "wrap": "NotificationDropdown-module__rMmnvq__wrap",
});
